import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData, updateData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';


const JournalEntryEdit = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [selectedOption, setSelectedOption] = useState(null);

    const [itemOptions, setItemOptions] = useState([]); // Store available item options
    const [selectedItemOption, setSelectedItemOption] = useState(null);
    const [amount, setAmount] = useState('');
    const [itemsList, setItemsList] = useState([]); // Store added items

    const [modalData, setModalData] = useState(null); // Modal data
    const [tableData, setTableData] = useState([]); // Table data for display


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchmaxbillno(true);

    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchData('JournelEntryApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.JournalEntry);
                    setItemsList(response.response_data.JournalEntryDetails);


                }
            })
            .catch((error) => {
                console.error('Error fetching JournelEntry Details:', error);
            });
    }, [id]);




    const submitData = async (e) => {
        e.preventDefault(); // Prevent form submission
        setIsLoading(true); // Set loading state

        if (!formData.Amount || formData.Amount <= 0) {
            setErrorMessage('Amount must be greater than 0!');
            setIsLoading(false);
            return;
        }

        if (itemsList.length === 0) {
            setErrorMessage('Please add at least one item to the list!');
            setIsLoading(false);
            return;
        }

        const updatedFormData = {
            Id: id,
            CompanyId: companyId,
            BranchId: branchId,
            BillDate: formData.BillDate,
            BillNo: formData.BillNo,
            MasterType: selectedMasterType?.value || formData.MasterType,
            CustomerId: selectedCustomer?.value || formData.CustomerId || null,
            SupplierId: selectedSupplier?.value || formData.SupplierId || null,
            AccountHeadId: selectedAccountHead?.value || formData.AccountHeadId || null,
            BankId: selectedBank?.value || formData.BankId || null,
            Amount: formData.Amount,
            IsType: selectedPaymentType,
            Remarks: formData.Remarks,
            CreatedBy: formData.CreatedBy,
            FinYear: formData.FinYear,
            CreatedDate: new Date().toISOString(),
            IsActive: true,
        };

        const updatedChildFormData = itemsList.map(item => ({
            JournalEntryId: 0,
            MasterType: item.MasterType || null,
            CustomerId: item.CustomerId || null,
            SupplierId: item.SupplierId || null,
            AccountHeadId: item.AccountHeadId || null,
            BankId: item.BankId || null,
            Amount: item.Amount,
            CreatedBy: formData.CreatedBy,
            CreatedDate: new Date().toISOString(),
            IsActive: true,
        }));


        // Combine Data for API
        const journelEntryVM = {
            JournalEntry: updatedFormData,
            JournalEntryDetails: updatedChildFormData,
        };

        updateData('JournelEntryApi', `${id}`, journelEntryVM, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/JournelEntryIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });

    };



    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: name === "IsType"
                ? value === "1"
                : name === "PaymentType"
                    ? Number(value) // Ensure PaymentType is stored as a number
                    : type === "checkbox"
                        ? checked
                        : value,
        }));


        let ispaymentType = true;

        if (name === "IsType") {
            ispaymentType = value === "1";
            setSelectedPaymentType(ispaymentType);
            fetchData('JournelEntryApi', `/MaxBillno/${companyId}/${branchId}/${ispaymentType}`, token)
                .then((response) => response.response_data)
                .then((data) => {
                    const currentDate = new Date();
                    const year = currentDate.getFullYear();
                    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                    const day = String(currentDate.getDate()).padStart(2, '0');
                    const formattedDate = `${year}-${month}-${day}`;

                    setFormData(prevData => ({
                        ...prevData,
                        BillNumber: data.BillNumber,
                        //BillNumber: `${data.BillNumber}/${data.FinYear}`,
                        BillNo: data.BillNumber,
                        BillDate: formattedDate,
                        FinYear: data.FinYear,
                        BranchId: branchId,
                        CompanyId: companyId,
                    }));
                })
                .catch((error) => {
                    console.error('Error fetching Max Billno:', error);
                });
        } else {

        }
    };


    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    // FOR Current Date and Time 
    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,
            BillDate: formattedDate,
            PaymentType: 1,
        }));
    }, []);



    // const addItemToList = () => {
    //     if (!selectedChildOption || !formData.CAmount || formData.CAmount <= 0) {
    //         setErrorMessage('Please select a valid item and enter a valid amount!');
    //         return;
    //     }
    //     const newItem = {
    //         slNo: itemsList.length + 1,
    //         MasterName: selectedChildOption.label,
    //         MasterId: selectedChildOption.value,
    //         Amount: formData.CAmount,
    //     };

    //     const updateddetails = [...itemsList, newItem];
    //     setItemsList(updateddetails);
    //     setErrorMessage('');
    //     setSelectedChildOption(null);

    //     let amt = updateddetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);

    //     setFormData((prev) => ({
    //         ...prev,
    //         CAmount: 0,
    //         Amount: amt,
    //     }));
    // };



    // Function to fetch MaxBillno

    const fetchmaxbillno = (Inputstring) => {
        // Use the parameter directly, no need to rely on formData here
        fetchData('JournelEntryApi', `/MaxBillno/${companyId}/${branchId}/${Inputstring}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                // Update formData with the fetched data
                setFormData((prevData) => ({
                    ...prevData,
                    BillNumber: data.BillNumber,
                    BillNo: data.BillNumber,
                    BillDate: formattedDate,
                    FinYear: data.FinYear,
                    BranchId: branchId,
                    CompanyId: companyId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Max Billno:', error);
            });
    };

    useEffect(() => {
        fetchmaxbillno(true);
    }, []);


    const [formData, setFormData] = useState({
        CompanyId: companyId,
        BillDate: '',
        BillNo: '',
        CustomerId: '',
        SupplierId: '',
        AccountHeadId: '',
        BankId: '',
        MasterType: '',

        // PaymentType: '',
        Amount: 0,
        Remarks: '',
        createdBy: userId,
        isSubmit: false,
        IsType: true, // 1 for Credit, 2 for Debit
        Amount1: 0,
    });


    //---------------------- MASTER -----------------------------
    //  Master Type

    const [masterTypeOptions, setMasterTypeOptions] = useState([]);
    const [selectedMasterType, setSelectedMasterType] = useState("");

    const fetchMasterType = async () => {
        try {

            const mtid = 0; // Replace with the actual ID you want to fetch
            const response = await fetchData('MasterTypeApi', `/${mtid}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setMasterTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleMasterTypeChange = (selectedOption) => {
        setSelectedMasterType(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            MasterType: selectedOption.value,
        }));
    };

    useEffect(() => {
        fetchMasterType();
    }, []);


    // its child data dropdowns 

    // Customers

    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState("");

    const fetchCustomers = async () => {
        try {

            const response = await fetchData('JournelEntryApi', `/Customer/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Name
                }));
                setCustomerOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleCustomersChange = (selectedOption) => {
        setSelectedCustomer(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            CustomerId: selectedOption.value,
        }));
    };

    useEffect(() => {
        fetchCustomers();
    }, []);


    // Suppliers

    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState("");

    const fetchSupplier = async () => {
        try {

            const response = await fetchData('JournelEntryApi', `/Supplier/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Name
                }));
                setSupplierOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleSupplierChange = (selectedOption) => {
        setSelectedSupplier(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            SupplierId: selectedOption.value,
        }));
    };

    useEffect(() => {
        fetchSupplier();
    }, []);

    // Account Head

    const [accountheadOptions, setAccountHeadOptions] = useState([]);
    const [selectedAccountHead, setSelectedAccountHead] = useState(null);

    const fetchAccountHead = async () => {
        try {
            const response = await fetchData('JournelEntryApi', `/AccountHead/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.ID,
                    label: item.Name
                }));
                setAccountHeadOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Account Head:', error);
        }
    };

    const handleAccountHeadChange = (selectedOption) => {
        setSelectedAccountHead(selectedOption);
        setFormData(prev => ({
            ...prev,
            AccountHeadId: selectedOption.value,
        }));
    };


    // Bank

    const [bankOptions, setBankOptions] = useState([]);
    const [selectedBank, setSelectedBank] = useState("");

    const fetchBank = async () => {
        try {
            const response = await fetchData('JournelEntryApi', `/Bank/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.AccountName
                }));
                setBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleBankChange = (selectedOption) => {
        setSelectedBank(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            BankId: selectedOption.value,
        }));
    };

    useEffect(() => {
        fetchBank();
    }, []);



    //---------------------- MASTER's CHILD DROPDOWNS -----------------------------
    //  Master Type

    const [masterTypeOptions1, setMasterTypeOptions1] = useState([]);
    const [selectedMasterType1, setSelectedMasterType1] = useState("");

    const fetchMasterType1 = async () => {
        try {

            const mtid = 0; // Replace with the actual ID you want to fetch
            const response = await fetchData('MasterTypeApi', `/${mtid}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setMasterTypeOptions1(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleMasterTypeChange1 = (selectedOption) => {
        setSelectedMasterType1(selectedOption);
    };

    useEffect(() => {
        fetchMasterType1();
    }, []);


    // its child data dropdowns 

    // Customers

    const [customerOptions1, setCustomerOptions1] = useState([]);
    const [selectedCustomer1, setSelectedCustomer1] = useState("");

    const fetchCustomers1 = async () => {
        try {

            const response = await fetchData('JournelEntryApi', `/Customer/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Name
                }));
                setCustomerOptions1(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleCustomersChange1 = (selectedOption) => {
        setSelectedCustomer1(selectedOption);
    };

    useEffect(() => {
        fetchCustomers1();
    }, []);


    // Suppliers

    const [supplierOptions1, setSupplierOptions1] = useState([]);
    const [selectedSupplier1, setSelectedSupplier1] = useState("");

    const fetchSupplier1 = async () => {
        try {

            const response = await fetchData('JournelEntryApi', `/Supplier/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Name
                }));
                setSupplierOptions1(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleSupplierChange1 = (selectedOption) => {
        setSelectedSupplier1(selectedOption);
    };

    useEffect(() => {
        fetchSupplier1();
    }, []);

    // Account Head

    const [accountheadOptions1, setAccountHeadOptions1] = useState([]);
    const [selectedAccountHead1, setSelectedAccountHead1] = useState(null); // ✅ FIXED

    useEffect(() => {
        fetchAccountHead1();
        fetchAccountHead();

        const handleResize = () => setIsFullScreen(window.innerWidth >= 768);
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchAccountHead1 = async () => {
        try {
            const response = await fetchData('JournelEntryApi', `/AccountHead/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.ID,
                    label: item.Name
                }));
                setAccountHeadOptions1(options);
            }
        } catch (error) {
            console.error('Error fetching Account Head 1:', error);
        }
    };

    const handleAccountHeadChange1 = (selectedOption) => {
        setSelectedAccountHead1(selectedOption);
    };

    // Bank

    const [bankOptions1, setBankOptions1] = useState([]);
    const [selectedBank1, setSelectedBank1] = useState("");

    const fetchBank1 = async () => {
        try {
            const response = await fetchData('JournelEntryApi', `/Bank/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.AccountName
                }));
                setBankOptions1(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleBankChange1 = (selectedOption) => {
        setSelectedBank1(selectedOption);
    };

    useEffect(() => {
        fetchBank1();
    }, []);


    const [selectedPaymentType, setSelectedPaymentType] = useState(true); // Default to Credit (true)
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');

    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Function to delete an item from the list
    const handleDelete = (slNo) => {
        const updatedList = itemsList.filter((item) => item.slNo !== slNo);

        // Recalculate total amount after deletion
        const updatedTotal = updatedList.reduce((sum, item) => sum + parseFloat(item.Amount), 0);

        // Update list and total amount
        setItemsList(updatedList);
        setFormData((prev) => ({
            ...prev,
            Amount: updatedTotal,
        }));
    };

    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === 'object') {
            name = e.target.name;
            value = e.target.value;
        } else {
            name = inputType;
            value = e;
        }

        // Assuming selectedItems is a state setter function (e.g., setSelectedItems)
        setItemsList((prevDetails) => {

            const updatedDetails = [...prevDetails];
            const currentItem = { ...updatedDetails[index], [name]: value };

            // Update the item in the copied array
            updatedDetails[index] = currentItem;

            const totals = updatedDetails.reduce(
                (acc, item) => {
                    acc.Amount += parseAndFix(item.Amount);
                    return acc;
                },
                { Amount: 0 }
            );

            totalCalculation(
                totals.Amount,
            );

            return updatedDetails;
        });
    };

    const parseAndFix = (val) => parseFloat(val) || 0;
    const totalCalculation = (Amount) => {

        setFormData((prev) => ({
            ...prev,
            Amount: Amount,
        }));
    };


    // FOR Current Date and Time 
    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,
            BillDate: formattedDate,
            PaymentType: 1,
        }));
    }, []);



    useEffect(() => {
        fetchmaxbillno(true);
    }, []);


    const addItemToList = () => {
        if (!selectedMasterType1) {
            setErrorMessage('Please select a Master Type option.');
            return;
        }

        const newItem = {
            slNo: itemsList.length + 1,
            PartyName:
                selectedAccountHead1?.label ||
                selectedCustomer1?.label ||
                selectedSupplier1?.label ||
                selectedBank1?.label ||
                '',
            CustomerId: selectedCustomer1?.value || null,
            SupplierId: selectedSupplier1?.value || null,
            AccountHeadId: selectedAccountHead1?.value || null,
            BankId: selectedBank1?.value || null,
            MasterType: selectedMasterType1.value,
            Amount: formData.Amount1 || 0,
        };

        const updatedDetails = [...itemsList, newItem];
        setItemsList(updatedDetails);
        setErrorMessage('');
        setSelectedCustomer1(null);
        setSelectedSupplier1(null);
        setSelectedAccountHead1(null);
        setSelectedBank1(null);
        setSelectedMasterType1(null);

        const totalAmt = updatedDetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);

        setFormData(prev => ({
            ...prev,
            Amount1: 0,
            Amount: totalAmt,
        }));
    };


    return (
        <Fragment>

            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%', marginTop: '-0.55%' }}>

                <div className="flex flex-wrap justify-between items-center mb-4">
                    <h6
                        className="uppercase tracking-wide text-black font-serif flex-grow"
                        style={{
                            fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                            color: 'black',
                            marginTop: '10px',
                        }}
                    >
                        Journal Entry Edit
                    </h6>
                    <div className="flex items-center w-full sm:w-auto sm:ml-4" style={{ marginRight: '120px', marginTop: '20px' }}>
                        <div className='w-full mb-2 flex'>

                            <label className="block tracking-wide text-gray-700 font-bold" style={{ color: 'darkblue' }}>
                                <input
                                    type="radio"
                                    name="IsType"
                                    value="1"
                                    checked={formData.IsType === true}
                                    onChange={handleChange}
                                />
                                Credit
                            </label>
                            <label className="block tracking-wide text-gray-700 font-bold ml-2" style={{ color: 'brown' }}>
                                <input
                                    type="radio"
                                    name="IsType"
                                    value="0"
                                    checked={formData.IsType === false}
                                    onChange={handleChange}
                                />
                                Debit
                            </label>

                        </div>
                    </div>

                    <div className="flex mt-8 w-full sm:w-auto">

                        <Button
                            style={{
                                background: 'linear-gradient(to right,rgb(11, 96, 55),rgb(98, 150, 61))',
                                color: 'white',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',

                            }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : <b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Update</b>}
                        </Button>

                        <Button
                            color="error"
                            component={Link}
                            to={{
                                pathname: "/JournelEntryIndex",
                                state: { from: "/JournelEntry" },
                            }}
                            onClick={() => {
                                localStorage.setItem('shouldReload', 'true');
                            }}
                            className="linkcolor"
                            style={{
                                background: 'linear-gradient(to right,rgb(73, 8, 8),rgb(221, 104, 104))',
                                color: 'white',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',

                            }}
                        >
                            <b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Cancel</b>
                        </Button>
                    </div>

                </div>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            {successMessage && <p className="text-green-500">{successMessage}</p>}

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>

            <div className="w-full flex flex-wrap md:flex-row flex-col">
                {/* Left Section: Entry Fields */}
                <div
                    className="flex-1 p-2"
                    style={{
                        backgroundColor: '#f3f3f3',
                        borderRadius: '10px',
                        marginTop: '-10px',
                    }}
                >
                    <div className="mb-3">
                        <div className="flex flex-wrap gap-x-4">
                            <div className="flex-1 w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="customer">
                                    Master Type<span className="text-red-500">*</span>
                                </label>
                                <Select
                                    //value={selectedMasterType}
                                    value={selectedMasterType || (formData.MasterTypeName ? { value: formData.MasterType, label: formData.MasterTypeName } : '')}
                                    onChange={handleMasterTypeChange}
                                    options={masterTypeOptions}
                                    placeholder="Master Type"
                                    isSearchable
                                />
                            </div>

                            <div className="flex-1 w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="customer">
                                    Party Name <span className="text-red-500">*</span>
                                </label>

                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="text"
                                    value={formData.PartyName}
                                    name="BillNo"
                                    readOnly
                                />
                            </div>



                            {/* Customer Dropdown */}
                            {selectedMasterType.value === 1 && (
                                <div className="flex-1 w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="customer">
                                        New  Party Name <span className="text-red-500">*</span>
                                    </label>
                                    <Select
                                        value={selectedCustomer}
                                        onChange={handleCustomersChange}
                                        options={customerOptions}
                                        placeholder="Select Customer"
                                        isSearchable
                                    />
                                </div>
                            )}

                            {/* Supplier Dropdown */}
                            {selectedMasterType.value === 2 && (
                                <div className="flex-1 w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="customer">
                                        New  Party Name <span className="text-red-500">*</span>
                                    </label>
                                    <Select
                                        value={selectedSupplier}
                                        onChange={handleSupplierChange}
                                        options={supplierOptions}
                                        placeholder="Select Supplier"
                                        isSearchable
                                    />
                                </div>
                            )}

                            {/* Account Head Dropdown */}
                            {selectedMasterType.value === 3 && (
                                <div className="flex-1 w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="customer">
                                        New  Party Name <span className="text-red-500">*</span>
                                    </label>
                                    <Select
                                        value={selectedAccountHead}
                                        onChange={handleAccountHeadChange}
                                        options={accountheadOptions}
                                        placeholder="Select Account Head"
                                        isSearchable
                                    />
                                </div>
                            )}

                            {/* Bank Dropdown */}
                            {selectedMasterType.value === 4 && (
                                <div className="flex-1 w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="customer">
                                        New  Party Name <span className="text-red-500">*</span>
                                    </label>
                                    <Select
                                        value={selectedBank}
                                        onChange={handleBankChange}
                                        options={bankOptions}
                                        placeholder="Select Bank"
                                        isSearchable
                                    />
                                </div>
                            )}
                        </div>

                        <div className="flex flex-wrap gap-x-4" style={{ marginTop: '0.75%' }}>
                            <div className="w-1/5  mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                    Date <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="date"
                                    value={formatDateForInput(formData.BillDate)}
                                    name="BillDate"
                                //onChange={handleChange}
                                />
                            </div>
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                    Bill No  <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="text"
                                    value={`${formData.BillNo || ''}/${formData.FinYear || ''}`}
                                    name="BillNo"
                                    readOnly
                                />
                            </div>

                            <div className="flex-1  mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="remarks">
                                    Remarks
                                </label>
                                <textarea
                                    rows="1"
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="text"
                                    value={formData.Remarks}
                                    name="Remarks"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="w-1/4  mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="amount">
                                    Amount
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline text-right"
                                    type="number"
                                    value={formData.Amount}
                                    name="Amount"
                                    onChange={handleChange}
                                    disabled

                                />
                            </div>
                        </div>
                        <div className="w-full mb-2 flex" style={{ marginTop: '0.75%' }}>
                            <div className="flex-1 w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="customer">
                                    Party Type<span className="text-red-500">*</span>
                                </label>
                                <Select
                                    value={selectedMasterType1}
                                    onChange={handleMasterTypeChange1}
                                    options={masterTypeOptions1}
                                    placeholder="Master Type"
                                    isSearchable
                                />
                            </div>

                            {/* Customer Dropdown */}
                            {selectedMasterType1 && selectedMasterType1.value === 1 && (
                                <div className="flex-1 w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="customer">
                                        Party Name <span className="text-red-500">*</span>
                                    </label>
                                    <Select
                                        value={selectedCustomer1}
                                        onChange={handleCustomersChange1}
                                        options={customerOptions1}
                                        placeholder="Select Customer"
                                        isSearchable
                                    />
                                </div>
                            )}

                            {/* Supplier Dropdown */}
                            {selectedMasterType1 && selectedMasterType1.value === 2 && (
                                <div className="flex-1 w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="customer">
                                        Party Name <span className="text-red-500">*</span>
                                    </label>
                                    <Select
                                        value={selectedSupplier1}
                                        onChange={handleSupplierChange1}
                                        options={supplierOptions1}
                                        placeholder="Select Supplier"
                                        isSearchable
                                    />
                                </div>
                            )}

                            {/* Account Head Dropdown */}
                            {selectedMasterType1 && selectedMasterType1.value === 3 && (
                                <div className="flex-1 w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="customer">
                                        Party Name <span className="text-red-500">*</span>
                                    </label>

                                    <Select
                                        value={selectedAccountHead1}
                                        onChange={handleAccountHeadChange1}
                                        options={accountheadOptions1}
                                        placeholder="Select Head"
                                        isSearchable
                                    />
                                </div>
                            )}

                            {/* Bank Dropdown */}
                            {selectedMasterType1 && selectedMasterType1.value === 4 && (
                                <div className="flex-1 w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="customer">
                                        Party Name <span className="text-red-500">*</span>
                                    </label>
                                    <Select
                                        value={selectedBank1}
                                        onChange={handleBankChange1}
                                        options={bankOptions1}
                                        placeholder="Select Bank"
                                        isSearchable
                                    />
                                </div>
                            )}


                            {/* <div className="w-1/8 mr-2" style={{ marginTop: '1.30%' }}> */}
                            <div className="w-1/4 mr-2" style={{ marginTop: '1.30%' }}>
                                <label
                                    className="block uppercase tracking-wide text-black text-xs font-bold mr-2"
                                    htmlFor="MinimumStock"
                                >
                                    Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                    type="number"
                                    value={formData.Amount1}
                                    onChange={handleChange}
                                    placeholder="Enter Amount"
                                    name="Amount1"
                                    step="0.01"  // Allow decimals
                                    style={{ textAlign: 'right' }}
                                    min={0}
                                />
                            </div>


                            {/* Add Button */}
                            <div className="w-1/6 mr-2" style={{ marginTop: '3.90%' }}>
                                <Tooltip title="Add Item" arrow>
                                    <button className="px-4 py-2 rounded"
                                        onClick={addItemToList}
                                        style={{
                                            color: 'white',
                                            fontWeight: 'bolder',
                                            textTransform: 'none',
                                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                            maxHeight: '35px',
                                            marginLeft: '6px',
                                            backgroundColor: '#D3F1DF'
                                        }}>
                                        <span style={{ marginTop: '2%', color: 'black' }}>+</span>
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Section: Table */}
                <div className="flex-1 p-4">
                    <div className="rounded-lg shadow overflow-hidden" style={{ backgroundColor: '#EDDFE0', marginTop: '-1.95%' }}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                    <TableRow>
                                        <TableCell colSpan={4} sx={{ textAlign: 'center', fontWeight: 'bold', color: 'darkblue', padding: '4px' }}>
                                            SELECTED MASTER LIST
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ padding: '4px' }}>Sl.No</TableCell>
                                        <TableCell style={{ padding: '4px' }}>Party</TableCell>
                                        <TableCell style={{ padding: '4px' }}>Amount</TableCell>
                                        <TableCell style={{ padding: '4px' }}>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {itemsList.length > 0 ? (
                                        itemsList.map((masterrelation, index) => (
                                            <TableRow key={index}>
                                                <TableCell style={{ padding: '3px' }}>{index + 1}</TableCell>
                                                <TableCell style={{ padding: '3px' }}>{masterrelation.PartyName}</TableCell>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '100px' }}>
                                                    <input
                                                        type="number"
                                                        value={masterrelation.Amount}
                                                        className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#D1F8EF', textAlign: 'right' }}
                                                        min="0"
                                                        aria-label={`amount for master ${masterrelation.Id}`}
                                                        name="Amount"
                                                        onChange={(e) => handleCalculation(e, index, 'Amount')}
                                                    />
                                                </td>
                                                <TableCell style={{ padding: '3px' }}>
                                                    <IconButton color="error" onClick={() => handleDelete(masterrelation.slNo)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                No Items Selected
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>

        </Fragment >
    );
};


export default JournalEntryEdit;
